import React, { useEffect } from 'react';
import { Routes, Route, Navigate, useResolvedPath } from 'react-router-dom';
import { observer } from 'mobx-react';
import AssessmentsViewWrapper from './AssessmentsViewWrapper';
import { useStores } from '../../hooks/use-stores';
import AssessmentsAnswerView from './AssessmentsAnswerView';
import AssessmentsList from './AssessmentsList';
import HomeViewContainer from '../Home/HomeViewContainer';

export default observer(
    ({ companyId, isAssessmentEnabled, currentCompany }) => {
        const {
            assessmentStore,
            store,
            authStore,
            questionStore,
            commonStore,
        } = useStores();
        const { currentUser } = authStore;
        const { effectiveLanguages: availableLanguages } = commonStore;
        const resolved = useResolvedPath('.');
        const baseUrl = resolved.pathname;
        useEffect(() => {
            store.resetContext();
        }, [companyId, store]);

        const language = store.language;

        if (currentCompany) {
            return isAssessmentEnabled ? (
                <Routes>
                    <Route
                        index
                        element={
                            <HomeViewContainer
                                layoutTitle="Awareness and Compliance Assessment"
                                code={'assessments'}
                                pageTitle={'assessments'}
                                content={<AssessmentsList />}
                            />
                        }
                    />

                    <Route
                        path=":assessmentId/answers"
                        element={
                            <AssessmentsViewWrapper  Component={AssessmentsAnswerView}
                                companyId={companyId} parentUrl={ baseUrl}
                                assessmentStore={assessmentStore}
                                questionStore={questionStore}
                                currentUser={currentUser}
                            />
                        }
                    />

                    <Route
                        path=":assessmentId"
                        element={
                            <AssessmentsViewWrapper
                                parentUrl={baseUrl}
                                availableLanguages={availableLanguages}
                                companyId={companyId}
                                currentUser={currentUser}
                                assessmentStore={assessmentStore}
                                questionStore={questionStore}
                                language={language}
                            />
                        }
                    />
                </Routes>
            ) : (
                <Navigate to="/" />
            );
        } else {
            return null;
        }
    }
);
